class AdBlockerChecker {
  static blockedErrorMsgRegexp = /TypeError|Failed to fetch|Network|blocked by content blocker/i

  constructor(url, options) {
    this.url = url
    this.options = options || { method: "HEAD", mode: "no-cors" }
  }

  async call(onSuccess, onError) {
    try {
      await fetch(this.url, this.options)
      onSuccess()
    } catch (e) {
      if (e.message.match(this.blockedErrorMsgRegexp)) {
        onError(e) // Request failed likely due to a content blocker
      } else {
        throw e
      }
    }
  }
}

export default AdBlockerChecker
